module.exports = __webpack_public_path__ + "static/media/rise_doc1.eae91371.jpg";